<template>{{outlet}}</template>
